var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RateBox = RateBox;
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _dsWeb = require("@olxbr/ds-web");
var _dsIcons = require("@olxbr/ds-icons");
var _rateStorage = _interopRequireDefault(require("./rateStorage"));
var _lurker = _interopRequireDefault(require("../../../utils/lurker"));
var _TextBody = require("../../atoms/TextBody");
var _jsxRuntime = require("react/jsx-runtime");
var _templateObject,
  _templateObject2,
  _this = this,
  _jsxFileName = "/Users/natalia.silva/Documents/OLX-PROJECTS/chatmod-react-components/packages/web/src/components/molecules/RateBox/index.js";
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var DividerModal = (0, _styledComponents["default"])(_dsWeb.Divider)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  width: 100%;\n  height: 1px;\n"])));
var CustomFlex = (0, _styledComponents["default"])(function (props) {
  return (0, _jsxRuntime.jsx)(_dsWeb.Flex, Object.assign({}, props));
})(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  width: 100%;\n"])));
function RateBox(_ref) {
  var lurkerObjName = _ref.lurkerObjName,
    luckerDetail = _ref.luckerDetail,
    idLocalStorage = _ref.idLocalStorage,
    chatId = _ref.chatId,
    isMobile = _ref.isMobile;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isRated = _useState2[0],
    setIsRated = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    isHidding = _useState4[0],
    setHidding = _useState4[1];
  (0, _react.useEffect)(function () {
    function closedIfPersisted() {
      return _closedIfPersisted.apply(this, arguments);
    }
    function _closedIfPersisted() {
      _closedIfPersisted = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee() {
        var rated;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _rateStorage["default"].isIn(idLocalStorage);
            case 2:
              rated = _context.sent;
              setHidding(rated);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _closedIfPersisted.apply(this, arguments);
    }
    closedIfPersisted();
  }, [chatId, setHidding]);
  if (isHidding) {
    return (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
  }
  var _onClick = function () {
    var _ref2 = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee2(rate) {
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _lurker["default"].sendClickRate("".concat(luckerDetail, "_").concat(rate), lurkerObjName, {
              chat_id: chatId,
              idLocalStorage: idLocalStorage
            });
            setIsRated(true);
            _context2.next = 4;
            return _rateStorage["default"].put(idLocalStorage);
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function onClick(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  if (!isRated) {
    return (0, _jsxRuntime.jsxs)(CustomFlex, {
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      children: [(0, _jsxRuntime.jsx)(DividerModal, {}), (0, _jsxRuntime.jsx)(_TextBody.TextBody, {
        marginTop: "--spacing-2",
        marginBottom: "--spacing-1",
        isMobile: isMobile,
        children: "Essas informa\xE7\xF5es foram \xFAteis?"
      }), (0, _jsxRuntime.jsxs)(CustomFlex, {
        flexDirection: "row",
        justifyContent: "center",
        alignItem: "center",
        children: [(0, _jsxRuntime.jsx)(_dsWeb.Button, {
          size: "small",
          variant: "neutral",
          fullWidth: isMobile,
          icon: (0, _jsxRuntime.jsx)(_dsIcons.ThumbsDown, {
            size: "16"
          }),
          marginRight: "--spacing-2",
          onClick: function onClick() {
            return _onClick('negative');
          },
          children: "N\xE3o"
        }), (0, _jsxRuntime.jsx)(_dsWeb.Button, {
          size: "small",
          variant: "neutral",
          fullWidth: isMobile,
          icon: (0, _jsxRuntime.jsx)(_dsIcons.ThumbsUp, {
            size: "16"
          }),
          onClick: function onClick() {
            return _onClick('positive');
          },
          children: "Sim"
        })]
      })]
    });
  }
  return (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: isRated && (0, _jsxRuntime.jsxs)(CustomFlex, {
      flexDirection: "column",
      alignItems: "center",
      children: [(0, _jsxRuntime.jsx)(DividerModal, {
        marginTop: "--spacing-1",
        marginBottom: "--spacing-2"
      }), (0, _jsxRuntime.jsxs)(_dsWeb.Flex, {
        children: [(0, _jsxRuntime.jsx)(_dsIcons.Check1Small, {
          color: "var(--color-feedback-success-120)"
        }), (0, _jsxRuntime.jsx)(_TextBody.TextBody, {
          color: "--color-feedback-success-120",
          isMobile: isMobile,
          children: "Agradecemos por nos ajudar :)"
        })]
      })]
    })
  });
}
var _default = RateBox;
exports["default"] = _default;